var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSites(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 69,
    height: 69,
    rx: 4.5,
    fill: "#007AFF",
    fillOpacity: 0.05,
    stroke: "#E0E0E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.9677 32.1959V23.086L35 18L26.0323 23.086V32.1959L18 36.7599V46.923L26.9677 52L35 47.4451L35.045 47.4721L43.0323 52L52 46.923V36.7599L43.9677 32.1959ZM26.0323 49.3715L19.8619 45.8697V38.8663L26.0323 42.368V49.3715ZM26.9228 40.7567L20.7884 37.282L26.9677 33.7802L27.0127 33.8073L33.1381 37.282L26.9677 40.7837L26.9228 40.7567ZM34.0646 45.8697L34.0196 45.8967L27.8942 49.3715V42.368L27.9392 42.341L34.0646 38.8663V45.8697ZM34.0646 35.6976L27.8942 32.1959V25.2015L34.0646 28.6942V35.6976ZM35 27.1189L34.955 27.0919L28.8296 23.6172L35 20.1154L35.045 20.1424L41.1794 23.6172L41.0355 23.6892L35 27.1189ZM42.1058 25.2015V32.1959L35.9355 35.6976V28.6942L42.1058 25.2015ZM42.1058 49.3715L41.9709 49.2904L35.9355 45.8697V38.8663L36.0614 38.9383L42.1058 42.368V49.3715ZM42.9873 40.7567L36.8619 37.282L36.9968 37.201L43.0323 33.7802L43.0772 33.8073L49.2116 37.282L49.0677 37.363L43.0323 40.7837L42.9873 40.7567ZM50.1381 45.8697L50.0931 45.8967L43.9677 49.3715V42.368L44.0127 42.341L50.1381 38.8663V45.8697Z",
    fill: "#007AFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSites);
export default __webpack_public_path__ + "static/media/Sites.1b64011320ba430c8a73ffcd54100153.svg";
export { ForwardRef as ReactComponent };